const licencesProducts = Object.freeze({
    pack_prospecting_sale: 'prospect',
    pack_invoicing_management: 'invoice',
    pack_all_included: 'suite'
});

const bonusPacks = Object.freeze({
    pack_support: 'support',
    pack_stock: 'stock',
});

const groupPacks = Object.freeze({
    cashflow: 'cashflow'
});

const groupedPacks = Object.freeze({
    pack_cashflow_starter: 'pack_cashflow_starter',
    pack_cashflow_pro: 'pack_cashflow_pro',
    pack_cashflow_business: 'pack_cashflow_business'
})

const licencesData = {
    prospect: {
        title: window.i18n.__('Vente'),
        description: window.i18n.__('Vendez plus vite, plus efficacement et gagnez un temps précieux sur vos tâches répétitives.'),
        link: ''
    },
    invoice: {
        title: window.i18n.__('Facturation'),
        description: window.i18n.__('Facturez et réalisez votre pré-comptabilité en toute simplicité, pour une gestion optimale de votre administratif.'),
        link: ''
    },
    suite: {
        title: window.i18n.__('Vente & Facturation'),
        description: window.i18n.__('Profitez de l’ensemble des fonctionnalités de prospection et vente ainsi que celles incluses dans gestion et facturation.'),
        link: ''
    },
};

const productsV3Data = {
    pack_crm: {
        title: window.i18n.__('Sellsy CRM')
    },
    pack_invoicing: {
        title: window.i18n.__('Facturation')
    },
    pack_management: {
        title: window.i18n.__('Pré-comptabilité')
    },
    pack_stock: {
        title: window.i18n.__('Stock')
    },
    pack_support: {
        title: window.i18n.__('Support')
    }
}

const bonusData = {
    support: {
        title: window.i18n.__('Support')
    },
    stock: {
        title: window.i18n.__('Stock')
    },
    cashflow: {
        title: window.i18n.__('Trésorerie'),
        link: 'https://go.sellsy.com/offres#gestiontresorerie'
    }
};

export {
    licencesProducts,
    licencesData,
    bonusPacks,
    bonusData,
    productsV3Data,
    groupPacks,
    groupedPacks
}